// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__NnUAd","description":"PatientConsentPreview_description__M_QWP"};